import { signOut } from "firebase/auth";
import { auth } from "firebaseClient";

function Signout() {
  return <button onClick={() => signOut(auth)}>Sign Out</button>;
}

export default Signout;
